import { faceSwapApiRequest } from './apiWrapper'
import { getCommonHeaders } from './apiWrapper'

export async function fetchFaceSwapTemplates() {
    const response = await faceSwapApiRequest({
        method: 'get',
        url: '/templates'
    })
    return response?.data || response
}

export async function fetchFaceSwapTemplateInfo(template_id) {
    const response = await faceSwapApiRequest({
        method: 'get',
        url: `/templates/${template_id}/info`
    })
    return response?.data || response
}

export async function uploadFaceSwapTemplate(payload) {
    const response = await faceSwapApiRequest({
        method: 'post',
        url: '/upload_template',
        data: payload,
        headers: {
            'Content-Type': 'application/json',
            ...getCommonHeaders()
        }
    })
    return response?.data || response
}

export async function uploadFaceSwapTargets(payload) {
    const response = await faceSwapApiRequest({
        method: 'post',
        url: '/upload_target_files',
        data: payload,
        headers: {
            'Content-Type': 'application/json',
            ...getCommonHeaders()
        }
    })
    return response?.data || response
}

/**
 * Performs face swap operation. Use target_indices to control single or multi-face swap:
 * - For single face: target_indices = [0]
 * - For multiple faces: target_indices = [0, 1, ...] (array of indices to swap)
 */
export async function swapFace(data) {
    const response = await faceSwapApiRequest({
        method: 'post',
        url: '/swap_face',
        data,
        headers: {
            'Content-Type': 'application/json',
            ...getCommonHeaders()
        }
    })
    return response?.data || response
}

export async function fetchFSImageStatus(generation_id) {
    const response = await faceSwapApiRequest({
        method: 'get',
        url: `/faceswap/status/${generation_id}`
    })
    return response?.data || response
}
